const AngleBracketsIcon = () => (
	<svg
		fill='currentColor'
		height='12'
		viewBox='0 0 20 12'
		width='20'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.3999 12L0.399902 6L6.3999 0L7.6749 1.275L2.9499 6L7.6749 10.725L6.3999 12ZM13.5999 12L12.3249 10.725L17.0499 6L12.3249 1.275L13.5999 0L19.5999 6L13.5999 12Z'
			fill='currentColor'
		/>
	</svg>
)

export { AngleBracketsIcon }
